import React from 'react';
import { Button } from 'react-bootstrap';

const ButtonFilterItem = ({ item }) => {
  const handleButtonClick = () => {
    if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <div className={`filter-item`}>
      <Button className="filter-item-btn" variant={''} onClick={handleButtonClick}>
        {item.icon && <img alt="Icon" src={item.icon} />}
        {item.label}
      </Button>
    </div>
  );
};

export default ButtonFilterItem;
